import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function Problem() {
  return <section className="bg-gray-50 py-24" data-id="element-122">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-l-8 border-red-600 shadow-xl rounded-r-2xl p-8 sm:p-12" data-id="element-124">
          <div className="flex items-center gap-4 mb-6" data-id="element-125">
            <AlertTriangle className="w-10 h-10 text-red-600 flex-shrink-0" data-id="element-126" />
            <h2 className="text-3xl sm:text-4xl text-brand-dark m-0" data-id="element-127">
              THE PROBLEM
            </h2>
          </div>

          <p className="text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed mb-6" data-id="element-128">
            Most hosts waste 45 minutes just{' '}
            <span className="bg-brand-yellow/30 px-2" data-id="element-129">"circling"</span>—walking
            from room to room with a bottle of spray, not knowing where to
            start.
          </p>

          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-130">
            You get distracted by deep-cleaning a baseboard while the guest's
            primary focus—the bathroom mirror and the bed—remains untouched.
          </p>

          <div className="bg-gray-100 p-6 rounded-lg border border-gray-200" data-id="element-131">
            <p className="text-gray-700 font-medium" data-id="element-132">
              Traditional cleaning checklists are designed for professional
              3-person crews with 6 hours to spare. When it's just you, your
              vacuum, and a ticking clock, those checklists are a recipe for
              burnout and bad reviews.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}